import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface GlassPanelProps {
  children: ReactNode;
  className?: string;
  blur?: number;
  opacity?: number;
  borderOpacity?: number;
  glowColor?: string;
  parallax?: number;
}

export default function GlassPanel({
  children,
  className = '',
  blur = 20,
  opacity = 8,
  borderOpacity = 20,
  glowColor = '#169fdb',
  parallax = 1
}: GlassPanelProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{
        transform: `translateY(${(1 - parallax) * 50}px)`,
        backdropFilter: `blur(${blur}px)`,
        backgroundColor: `rgba(255, 255, 255, ${opacity / 100})`,
        border: `1px solid rgba(255, 255, 255, ${borderOpacity / 100})`,
        boxShadow: `0 0 20px rgba(22, 159, 219, 0.15), 0 8px 32px rgba(0, 72, 153, 0.1)`
      }}
      className={`rounded-lg ${className}`}
    >
      {children}
    </motion.div>
  );
}